export const editSubVendorDialogData = (details) => [
  {
    placeholder: 'Name',
    required: true,
    type: 'text',
    name: 'name',
    label: 'Sub-Vendor Name',
    countrycode: false,
    defaultValue: details?.companyName || '',
  },
  {
    placeholder: 'Mobile Number',
    required: true,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    countrycode: true,
    defaultValue: details?.mobile?.replaceAll("+91","") || '',
  },
  {
    placeholder: 'Email',
    required: true,
    type: 'text',
    name: 'email',
    label: 'Email',
    countrycode: false,
    defaultValue: details?.email || '',
  },
  // {
  //   placeholder: 'Address',
  //   required: false,
  //   type: 'text',
  //   name: 'address',
  //   label: 'Address',
  //   multiline: true,
  //   row: 3,
  //   defaultValue: details?.address || '',
  // },
  // {
  //   placeholder: 'City',
  //   required: false,
  //   type: 'text',
  //   name: 'city',
  //   label: 'City',
  //   countrycode: false,
  //   defaultValue: details?.city || '',
  // },
  // {
  //   placeholder: 'State',
  //   required: false,
  //   type: 'text',
  //   name: 'state',
  //   label: 'State',
  //   countrycode: false,
  //   defaultValue: details?.state || '',
  // },
];

export const subDriverDialogData = () => [
  {
    placeholder: 'Name',
    required: true,
    type: 'text',
    name: 'driverName',
    label: ' Driver Name',
    star: '*',
    countrycode: false,
  },
  
  {
    placeholder: 'Mobile Number',
    required: true,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    star: '*',
    countrycode: true,
  },
  // {
  //   placeholder: 'Alternate Mobile Number',
  //   required: false,
  //   type: 'text',
  //   name: 'mobile',
  //   label: 'Alternate Mobile Number',
  //   star: '*',
  //   countrycode: true,
  // },
  // {
  //   placeholder: 'DD/MM/YYYY',
  //   required: false,
  //   type: 'date',
  //   name: 'birthday',
  //   label: 'Birthday Date',
  //   star: '*',
  //   countrycode: false,
  // },
  // {
  //   placeholder: 'Add Your Permanent Address',
  //   required: false,
  //   type: 'text',
  //   name: 'permanentaddress',
  //   label: 'Permanent Address',
  //   countrycode: false,
  //   multiline: true,
  //   row: 3,
  // },
  // {
  //   placeholder: 'Add Your Current Address',
  //   required: false,
  //   type: 'text',
  //   name: 'currentaddress',
  //   label: 'Current Address',
  //   countrycode: false,
  //   multiline: true,
  //   row: 3,
  // },
  // {
  //   placeholder: 'Yes or No',
  //   required: false,
  //   type: 'text',
  //   name: 'covid',
  //   label: 'Are You Covid Vaccinated ?',
  //   countrycode: false,
  // },
  {
    placeholder: 'Email',
    required: false,
    type: 'text',
    name: 'email',
    label: 'Email',
    star: '*',
    countrycode: false,
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'name',
    label: 'City Manager',
    star: '*',
    countrycode: false,
    disabled: true,
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'subVendor',
    label: 'Sub-Vendor Name',
    star: '*',
    countrycode: false,
    disabled: true,
  },
];
